import React from 'react';
import { ClockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-ink py-20 lg:py-24" data-id="element-58" data-mp="vgr16v8h9om9">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-59" data-mp="19fgx47jk9i91">
        <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-60" data-mp="19cuoe4kxowp8">
          Convertite en el entrenador que tus alumnos merecen tener.
        </h2>

        <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium text-white" data-id="element-61" data-mp="1jasc8qyvsrhb">
          <ClockIcon className="h-4 w-4 text-sunset" aria-hidden="true" data-id="element-62" data-mp="1t3g4r9itw9a8" />
          Precio promocional disponible por tiempo limitado.
        </p>

        <div className="mt-9" data-id="element-63" data-mp="1o4n2yecwm6pw">
          <CtaButton size="lg" location="cta-final" data-id="element-64" data-mp="223mimwifvb9x">
            Comprar Megapack ahora
          </CtaButton>
        </div>

        <p className="mt-7 inline-flex items-center gap-2 text-sm text-white/70" data-id="element-65" data-mp="1x5b62e0remo0">
          <ShieldCheckIcon className="h-4 w-4 text-nature" aria-hidden="true" data-id="element-66" data-mp="n5ukpyj01hf6" />
          Tu inversión está protegida por nuestra garantía de 7 días.
        </p>
      </div>
    </section>;
}